// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanDeletePolicy } from "./hook";

export type CanDeletePolicyProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanDeletePolicy({
  children,
  fallback,
  scope,
}: CanDeletePolicyProps) {
  const canDoAction = useCanDeletePolicy(scope);
  return <>{canDoAction ? children : fallback}</>;
}
